export default __webpack_public_path__ + "static/6-d39fa4ea6f62cd047a7227abaf150379.png";